<app-table [columns]="columns" [loading]="loading" [sortField]="'created'" [sortOrder]="sortOrder" [value]="approvals">
  <ng-template
    (onClick)="showDetail($event.row)"
    appActionButton
    icon="fal fa-search"
    labelKey="GLOBAL.DETAILS"></ng-template>
</app-table>
